import { render, staticRenderFns } from "./VCollapse.vue?vue&type=template&id=485f8308&"
import script from "./VCollapse.vue?vue&type=script&lang=js&"
export * from "./VCollapse.vue?vue&type=script&lang=js&"
import style0 from "./VCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports